module.exports = __webpack_public_path__ + "img/s-3.aeea25db.png";